import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TextField,
} from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import CreateBonuses from "./BonusesModal/Create";
import EditBonuses from "./BonusesModal/Edit";
import DeleteBonuses from "./BonusesModal/Delete";
import { EncryptStorage } from "encrypt-storage";
import Axios from "axios";
import ShowNoteComponent from "./ShowNoteComponent";
import FileUpload from "../Components/FileUpload";
import Loading from "../../../pages/Loading";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { debounce } from "lodash";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import GreenCheckBadge from "../Components/Badge";
const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function BonusesRow(props) {
  const { row, client_case_id, setBonuses } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);

  const handleChange = debounce(async (property, value) => {
    try {
      if (value && value._isAMomentObject) {
        const date_dt = new Date(value);
        const new_date = new Date(
          date_dt.getFullYear(),
          date_dt.getMonth(),
          date_dt.getDate(),
          10,
          56,
          0
        );
        row[property] = new_date;
      } else {
        row[property] = value;
      }

      const response = await Axios.put(
        `api/estate/bonuses/${row.id}`,
        row
      );

      if (response && response.status === 200) {
        setBonuses(response.data.data);
      }
    } catch (err) {
      console.error("Error updating property:", err);
    }
  }, 500); 
  
  const positions = [
    "Husband",
    "Wife",
    "Joint",
    "Client",
    "Spouse",
    "Third Party",
    "Other"
  ]; 

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.name ?? ""} <Position position ={row.position}/>
        </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.value ?? ""}
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.client_sp ?? ""}
          </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left"> 
          <ShowNoteComponent row={row} api='api/estate/bonuses'/>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteBonuses row={row} setBonuses={setBonuses} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'bonuses'}/>
          </div>
           <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Company :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.name} onChange={(e) => handleChange('name', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Date of expected payment :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                    <MuiPickersUtilsProvider utils={MomentUtils}> 
                      <KeyboardDateTimePicker
                        disableToolbar
                        variant="inline"
                        format="MM/DD/yyyy"  
                        onChange={(payment_date) => handleChange('payment_date', payment_date)}
                        className="m-0"
                        id="date-picker-inline"
                        value={new Date(row.payment_date)} 
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                      /> 
                    </MuiPickersUtilsProvider>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Time period covered :
                    </ListItemText>
                    
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                    <MuiPickersUtilsProvider utils={MomentUtils}> 
                      <KeyboardDateTimePicker
                        disableToolbar
                        variant="inline"
                        format="MM/DD/yyyy"  
                        onChange={(start_date) => handleChange('start_date', start_date)}
                        className="m-0"
                        id="date-picker-inline"
                        value={new Date(row.start_date)} 
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                      /> 
                    </MuiPickersUtilsProvider>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Amount of Bonus :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.value} onChange={(e) => handleChange('value', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.client_sp} onChange={(e) => handleChange('client_sp', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.spouse_sp} onChange={(e) => handleChange('spouse_sp', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                     <TextInputField defaultValue={row.net_value} disabled={true} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider /> 
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name/Control of:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                      <NativeSelect
                          className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                          inputProps={{
                            name: 'positions',
                          }}
                        //  defaultValue={formik.values.type}
                          onChange={(e) => handleChange('position', e.target.value)} 
                          defaultValue={row.position}
                        >
                        {
                          positions.map((position, index) => {
                            return (
                              <option key={index} value={position}>{position}</option>
                            )
                          })
                        } 
                        </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function Bonuses(props) {
  const { handleOpen } = props;
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [bonuses, setBonuses] = useState([]);
  const [open, setOpen] = useState(false);
  const fetch_data = () => {
    setOpen(true);
    Axios.get("api/estate/bonuses/" + client_case_id)
      .then((res) => {
        setBonuses(res.data.data);
        setOpen(false);
      })
      .catch((err) => {
        console.log("error", err);
        setOpen(false);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}>
         <div className="d-flex px-9 align-items-center">
                <div className="ml-auto">
                  <CreateBonuses
                    setBonuses={setBonuses}
                    client_case_id={client_case_id}
                    handleOpen={handleOpen}
                  />
                </div>
              </div>
        <div className="pb-10 pl-10 pr-10 pt-0">
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                    Description
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Value
                  </TableCell>
                  {/* <TableCell align="left" className="font-weight-bold text-uppercase text-muted fs-1">Debt</TableCell> */}
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Client SP
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Spouse SP
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Net Value
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bonuses.map((row) => (
                  <BonusesRow
                    key={row.id}
                    row={row}
                    client_case_id={client_case_id}
                    setBonuses={setBonuses}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {open && <Loading />}
      </div>
    </>
  );
}
export default Bonuses;
